<template>
  <unicom-linha>
    <unicom-coluna sm="12">
      <TabelaEndereco :idRnpPrestador="idRnpPrestador" />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import TabelaEndereco from "./componentes/TabelaEndereco/TabelaEndereco";

export default {
  components: {
    TabelaEndereco
  },
  props: {
    idRnpPrestador: {
      type: [String, Number]
    }
  }
};
</script>

<style></style>
